import { gql } from '@apollo/client';

export const CREATE_ABSENCE = gql`
  mutation CreateAbsence($record: CreatePractitionerAbsenceInput!) {
    user {
      dashboardUser {
        createPractitionerAbsence(record: $record) {
          ok
          error {
            message
            code
          }
          resultId
          result {
            id
            note
            startDate
            endDate
          }
        }
      }
    }
  }
`;
